import { StoreSlice } from '../Store';

type SidebarStore = {
  isOpen: boolean;
};

type SidebarActions = {
  toggleSidebar: (open?: boolean) => void;
};

export type SidebarSlice = SidebarStore & SidebarActions;

export const createSidebarSlice: StoreSlice<SidebarSlice> = (set) => ({
  isOpen: false,

  toggleSidebar: (open) =>
    set((prevState) => {
      prevState.sidebar.isOpen = open ?? !prevState.sidebar.isOpen;
    }),
});
